// extracted by mini-css-extract-plugin
export default {"analysisPane":"AnalysisPane-module__analysisPane__rjXYf"};